"use strict";
var Observable_1 = require('../../Observable');
var repeat_1 = require('../../operator/repeat');
Observable_1.Observable.prototype.repeat = repeat_1.repeat;
//# sourceMappingURL=repeat.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/repeat.js